<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M18 21l-4-4h3V7h-3l4-4 4 4h-3v10h3M2 19v-2h10v2M2 13v-2h7v2M2 7V5h4v2H2z"/>
    </svg>
</template>

<script>
export default {
    name: 'SortIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
